import { render, staticRenderFns } from "./ReportExpenses.vue?vue&type=template&id=a0b54564&scoped=true&"
import script from "./ReportExpenses.vue?vue&type=script&lang=js&"
export * from "./ReportExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b54564",
  null
  
)

export default component.exports